module.exports = __webpack_public_path__ + "static/img16-91bb54205f0f3f8d361ffa934d6af313.jpg";